<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 8">
      <g
        id="stand 1"
        clip-path="url(#clip0)"
      >
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M18.827 17.8105H1.17267V20H18.827V17.8105Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path
              id="Vector_2"
              d="M20 5.09757V4.26733H0V5.09757C0 5.81647 0.503789 6.41952 1.17676 6.57331V11.3266H0V16.6388H20V11.3266H18.8232V6.57327C19.4962 6.41948 20 5.81644 20 5.09757ZM17.6513 11.3266H2.34863V11.3266V6.36022C2.49402 6.26382 2.62191 6.14308 2.72637 6.0037C3.00277 6.37257 3.44328 6.61163 3.93863 6.61163C4.43398 6.61163 4.87449 6.37257 5.1509 6.0037C5.4273 6.37257 5.86781 6.61163 6.36316 6.61163C6.85852 6.61163 7.29902 6.37257 7.57543 6.0037C7.85184 6.37257 8.29234 6.61163 8.78769 6.61163C9.28305 6.61163 9.72355 6.37257 9.99996 6.0037C10.2764 6.37257 10.7169 6.61163 11.2122 6.61163C11.7076 6.61163 12.1481 6.37257 12.4245 6.0037C12.7009 6.37257 13.1414 6.61163 13.6368 6.61163C14.1321 6.61163 14.5726 6.37257 14.849 6.0037C15.1254 6.37257 15.5659 6.61163 16.0613 6.61163C16.5566 6.61163 16.9971 6.37257 17.2736 6.0037C17.378 6.14304 17.5059 6.26378 17.6513 6.36022V11.3266Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path
              id="Vector_3"
              d="M20 0H0V3.0957H20V0Z"
              fill="white"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'SvgExpoHall',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>

<style>

</style>
